export enum SedsThemeColorOptions {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  ACCENT = 'accent',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  WHITE = 'white',
  QUESTION = 'question',
  GREY = 'greyscale',
  GREY_DARKER = 'greyscale-darker',
  BRAND_PRIMARY = 'brand-primary',
  BRAND_PRIMARY_LIGHT = 'brand-primary-light',
  BRAND_PRIMARY_DARK = 'brand-primary-dark',
  BRAND_ALT = 'brand-alt',
  BRAND_ALT_LIGHT = 'brand-alt-light',
  BRAND_ALT_DARK = 'brand-alt-dark',
  BRAND_SECONDARY = 'brand-secondary',
  BRAND_SECONDARY_LIGHT = 'brand-secondary-light',
  BRAND_SECONDARY_DARK = 'brand-secondary-dark',
  BRAND_TERTIARY = 'brand-tertiary',
  BRAND_TERTIARY_LIGHT = 'brand-tertiary-light',
  BRAND_TERTIARY_DARK = 'brand-tertiary-dark',
  NEUTRAL_WHITE = 'neutral-white',
  NEUTRAL_GREY = 'neutral-grey',
  NEUTRAL_GREY_LIGHT = 'neutral-grey-light',
  NEUTRAL_GREY_DARK = 'neutral-grey-dark',
  NEUTRAL_BLACK = 'neutral-black',
  NEUTRAL_BLACK_LIGHT = 'neutral-black-light',
  NEUTRAL_BLACK_DARK = 'neutral-black-dark',
  FEEDBACK_SUCCESS = 'feedback-success',
  FEEDBACK_SUCCESS_LIGHT = 'feedback-success-light',
  FEEDBACK_SUCCESS_DARK = 'feedback-success-dark',
  FEEDBACK_WARNING = 'feedback-warning',
  FEEDBACK_WARNING_LIGHT = 'feedback-warning-light',
  FEEDBACK_WARNING_DARK = 'feedback-warning-dark',
  FEEDBACK_ERROR = 'feedback-error',
  FEEDBACK_ERROR_LIGHT = 'feedback-error-light',
  FEEDBACK_ERROR_DARK = 'feedback-error-dark',
  DATA_TEAL = 'data-teal',
  DATA_TEAL_LIGHT = 'data-teal-light',
  DATA_TEAL_DARK = 'data-teal-dark',
  DATA_SAPPHIRE = 'data-sapphire',
  DATA_SAPPHIRE_LIGHT = 'data-sapphire-light',
  DATA_SAPPHIRE_DARK = 'data-sapphire-dark',
  DATA_YELLOW = 'data-yellow',
  DATA_YELLOW_LIGHT = 'data-yellow-light',
  DATA_YELLOW_DARK = 'data-yellow-dark',
  DATA_LIME = 'data-lime',
  DATA_LIME_LIGHT = 'data-lime-light',
  DATA_LIME_DARK = 'data-lime-dark',
}
